import { Children, FC, ReactNode } from 'react'
import { Stack, StackProps } from '@mui/material'

export interface BarLayoutProps extends Partial<StackProps> {
  children?: ReactNode
  shrinkLeft?: boolean
  shrinkRight?: boolean
  leftCtnProps?: Partial<StackProps>
  rightCtnProps?: Partial<StackProps>
}

export const BarLayout: FC<BarLayoutProps> = ({
  children,
  shrinkLeft = false,
  shrinkRight = false,
  leftCtnProps = {},
  rightCtnProps = {},
  ...props
}) => {
  const [firstChild, secondChild, ...restChildren] = Children.toArray(children)

  return (
    <Stack
      spacing={1}
      {...props}
      sx={[
        {
          flexGrow: 1,
          width: '100%',
        }, // MUI's SxProps union is `any`-tainted, so the spread reads as unsafe.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          {...leftCtnProps}
          sx={[
            {
              alignItems: 'center',
            }, // MUI's SxProps union is `any`-tainted, so the spread reads as unsafe.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ...(Array.isArray(leftCtnProps.sx) ? leftCtnProps.sx : [leftCtnProps.sx]),
            shrinkLeft && { flexShrink: 1, minWidth: 0 },
            shrinkRight && { flexShrink: 0 },
            leftCtnProps.sx,
          ]}
        >
          {firstChild}
        </Stack>
        {secondChild && (
          <Stack
            direction="row"
            spacing={1}
            {...rightCtnProps}
            sx={[
              {
                alignItems: 'center',
              }, // MUI's SxProps union is `any`-tainted, so the spread reads as unsafe.
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              ...(Array.isArray(rightCtnProps.sx) ? rightCtnProps.sx : [rightCtnProps.sx]),
              shrinkRight && { flexShrink: 1, minWidth: 0 },
              shrinkLeft && { flexShrink: 0 },
              rightCtnProps.sx,
            ]}
          >
            {secondChild}
          </Stack>
        )}
      </Stack>
      {restChildren}
    </Stack>
  )
}
